export const LEFT_PANEL_PAGE_SIZE = 10
